import React from "react";
import AccessTimeIcon from "@material-ui/icons/AccessTime";
import { getPlayHudReservedZoneHeight } from "./escapeRoomEditorConstants";

/**
 * Franja guía en el lienzo del editor: marca dónde aparece el temporizador (y puntuación) en juego.
 */
export function EscapeRoomPlayHudZoneOverlay({ viewportId = "desktop", showScore = true }) {
	const height = getPlayHudReservedZoneHeight(viewportId);
	return (
		<div
			data-er-editor-ui="1"
			aria-hidden
			title="Zona reservada para el temporizador en juego"
			style={{
				position: "absolute",
				top: 0,
				left: 0,
				right: 0,
				height,
				zIndex: 8,
				pointerEvents: "none",
				boxSizing: "border-box",
				background:
					"linear-gradient(180deg, rgba(148, 163, 184, 0.38) 0%, rgba(148, 163, 184, 0.16) 72%, rgba(148, 163, 184, 0.04) 100%)",
				borderBottom: "1px dashed rgba(100, 116, 139, 0.5)",
			}}
		>
			<div
				style={{
					display: "flex",
					alignItems: "center",
					justifyContent:
						viewportId === "mobile"
							? "flex-end"
							: showScore
								? "space-between"
								: "center",
					padding: viewportId === "mobile" ? "10px 12px 0 0" : "10px 12px 0",
					gap: 8,
					height: "100%",
					boxSizing: "border-box",
				}}
			>
				<div
					style={{
						display: "inline-flex",
						alignItems: "center",
						gap: 6,
						padding: "5px 12px",
						borderRadius: 999,
						background: "rgba(255, 255, 255, 0.55)",
						border: "1px dashed rgba(100, 116, 139, 0.45)",
						color: "#64748b",
						fontSize: 11,
						fontWeight: 700,
						letterSpacing: "0.02em",
						fontVariantNumeric: "tabular-nums",
					}}
				>
					<AccessTimeIcon style={{ fontSize: 14, opacity: 0.85 }} />
					<span>Tiempo</span>
				</div>
				{showScore ? (
					<div
						style={{
							display: "inline-flex",
							alignItems: "center",
							justifyContent: "center",
							minWidth: 36,
							padding: "5px 12px",
							borderRadius: 999,
							background: "rgba(255, 255, 255, 0.45)",
							border: "1px dashed rgba(100, 116, 139, 0.35)",
							color: "#94a3b8",
							fontSize: 11,
							fontWeight: 700,
						}}
					>
						Pts
					</div>
				) : null}
			</div>
		</div>
	);
}
